/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit';
// api
import { getPanelScoreList } from '../../api/score';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  taskId: null,
  list: {
    // [taskId]: {
    //   items: null,
    //   users: [],
    // },
  },
  scoreInfo: {
    items: null,
    users: [],
  },
  /**
   * @description user list [{ ...user_info , score_list : []} , {...}]
   */
  scoreList: [],
  // 重置分数
  resetPost: null,
};

const slice = createSlice({
  name: 'score',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    setTaskId(state, action) {
      state.isLoading = false;
      state.taskId = action.payload || null;
      state.scoreInfo = initialState.scoreInfo;
    },
    setScoreList(state, action) {
      state.isLoading = false;
      state.scoreList = action.payload || [];
    },
    getScoreInfoSuccess(state, action) {
      state.isLoading = false;
      state.scoreInfo = action.payload || [];
    },
    /**
     * Update score from websocket message
     * @param {*} state
     * @param {*} action
     * @returns
     */
    updateScore(state, action) {
      const { payload } = action;
      if (!payload) {
        return;
      }
      const {
        post: { task_id: taskId, score_data: assignUsers },
      } = payload;

      assignUsers.map((assignUser) => {
        if (assignUser.ns_user_id) {
          const nsUserIdx = state.scoreList.findIndex(
            (nsUser) => nsUser.ns_user_id === assignUser.ns_user_id
          );
          if (nsUserIdx === -1) {
            return false;
          }
          const nsUser = state.scoreList[nsUserIdx];
          const idx = (nsUser?.score_list || []).findIndex(
            (nsUserScore) =>
              nsUserScore.ns_user_id === assignUser.ns_user_id &&
              nsUserScore.task_id === assignUser.task_id &&
              nsUserScore.task_id.toString() === (taskId || '').toString()
          );
          // const idx = (state.scoreInfo?.users || []).findIndex(
          //   (user) => user.ns_user_id === assignUser.ns_user_id
          // );
          if (idx > -1) {
            state.scoreList[nsUserIdx].score_list[idx] = {
              ...state.scoreList[nsUserIdx].score_list[idx],
              comment: assignUser.comment,
              score: assignUser.score,
              val_id: assignUser.val_id,
            };
          } else {
            state.scoreList[nsUserIdx].score_list.push(assignUser);
          }
          return true;
        }
        return false;
      });
    },
    /**
     * Update comment from websocket message
     * @param {*} state
     * @param {*} action
     */
    updateComment(state, action) {
      const { payload } = action;
      if (!payload) {
        return;
      }
      const {
        post: {
          task_id: taskId,
          comment,
          ns_user_id: NSUserId,
          phase_id: phaseId,
          is_score
        },
      } = payload;

      if (NSUserId && taskId) {
        const nsUserIdx = (state.scoreList || []).findIndex(
          (user) => user.ns_user_id === NSUserId
        );
        if (nsUserIdx === -1) {
          return;
        }
        const nsUser = state.scoreList[nsUserIdx];
        const idx = (nsUser?.score_list || []).findIndex(
          (nsUserScore) =>
            nsUserScore.ns_user_id === NSUserId &&
            nsUserScore.task_id === taskId
        );
        if (idx > -1 && (state.scoreList || [].length > 0)) {
          state.scoreList[nsUserIdx].score_list[idx] = {
            ...state.scoreList[nsUserIdx].score_list[idx],
            comment,
          };
        } else {
          state.scoreList[nsUserIdx].score_list.push({
            task_id: taskId,
            ns_user_id: NSUserId,
            phase_id: phaseId,
            comment,
            is_score
          });
        }
      }
    },
    /**
     * update score from websocket message in single mode
     * @param {*} state
     * @param {*} action
     */
    addUserScore(state, action) {
      const { payload } = action;
      if (!payload) {
        return;
      }
      const {
        post: {
          task_id: taskId,
          ns_user_id: nsUserId,
          phase_id: phaseId,
          score,
          is_score,
        },
      } = payload;
      console.log('nsUserId', nsUserId);
      if (nsUserId && taskId) {
        const nsUserIdx = state.scoreList.findIndex(
          (nsUser) => nsUser.ns_user_id === nsUserId
        );
        if (nsUserIdx === -1) {
          return;
        }
        const nsUser = state.scoreList[nsUserIdx];
        const idx = (nsUser?.score_list || []).findIndex(
          (nsUserScore) =>
            nsUserScore.ns_user_id === nsUserId &&
            nsUserScore.task_id === taskId
        );
        if (idx > -1) {
          state.scoreList[nsUserIdx].score_list[idx] = {
            ...state.scoreList[nsUserIdx].score_list[idx],
            score,
          };
        } else {
          state.scoreList[nsUserIdx].score_list.push({
            task_id: taskId,
            ns_user_id: nsUserId,
            phase_id: phaseId,
            score,
            is_score,
          });
        }
      }
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setResetPost(state, action) {
      state.editLoading = false;
      state.resetPost = action.payload.post;
      const { phase_id, ns_user_id, task_id } = action.payload.post;
      const ScortListIndex = (state.scoreList || []).findIndex(
        (item) => item.ns_user_id === ns_user_id
      );
      if (ScortListIndex !== -1) {
        const ScortList = state.scoreList[ScortListIndex];
        const ScontItemindex = ScortList.score_list.findIndex(
          (item) => item.ns_user_id === ns_user_id && item.task_id === task_id
        );
        if (ScontItemindex !== -1) {
          if (
            state.scoreList[ScortListIndex].score_list[ScontItemindex].type ===
            'TEXTAREA'
          ) {
            state.scoreList[ScortListIndex].score_list[ScontItemindex] = {
              ...state.scoreList[ScortListIndex].score_list[ScontItemindex],
              comment: null,
            };
          } else {
            state.scoreList[ScortListIndex].score_list[ScontItemindex] = {
              ...state.scoreList[ScortListIndex].score_list[ScontItemindex],
              score: null,
            };
          }
        }
      }
    },
    ClearResetPost(state, action) {
      state.isLoading = false;
      state.resetPost = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

export const {
  setScoreList,
  getScoreInfoSuccess,
  updateScore,
  addUserScore,
  updateComment,
  setTaskId,
  setResetPost,
  ClearResetPost,
} = slice.actions;

// ----------------------------------------------------------------------
export function getScoreList(parms) {
  return async (dispatch) => {
    !parms.notLoading && dispatch(slice.actions.startLoading());
    try {
      const response = await getPanelScoreList(parms);
      dispatch(slice.actions.getScoreInfoSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
